import {FormInputText} from "base/form/components";
import Grid from "@mui/material/Grid";
import TransportFormDatePickerCombo from "./TransportFormDatePickerCombo";

const PermitApplicationTransportFormFields = ({disabled, isExtension = false}) => {
    return (
        <Grid container columnSpacing={1}>
            <TransportFormDatePickerCombo
                startDateName={"transport_start_date"}
                startDateLabel={isExtension ? "Nova data de início" : "Data de início"}
                endDateName={"transport_end_date"}
                endDateLabel={
                    isExtension ? "Nova data de caducidade" : "Data de caducidade"
                }
                required={isExtension ? true : false}
                disabled={disabled}
            />
            {isExtension ? null : (
                <>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="transport_beneficiary"
                            label="Beneficiário/a"
                            disabled={disabled}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInputText
                            name="transport_destination"
                            label="Destino"
                            disabled={disabled}
                            rules={{required: "Este campo é obrigatório."}}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default PermitApplicationTransportFormFields;
